/**
 * Location Gallery Lightbox
 *
 * Scoped controller for the `photo-gallery-lightbox` snippet. Supports multiple
 * galleries on a single page. Binds via `data-` hooks only (no hard-coded IDs).
 *
 * Features: open/close, prev/next with wrap-around, counter, keyboard
 * (ArrowLeft/ArrowRight/Escape), focus trap, focus restore, backdrop dismissal,
 * and body-scroll lock.
 */
;(function () {
  'use strict'

  var FOCUSABLE = 'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'

  function initGallery(gallery) {
    var lightbox = gallery.querySelector('[data-gallery-lightbox]')
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'))
    if (!lightbox || thumbs.length === 0) return

    var imageEl = lightbox.querySelector('[data-lightbox-image]')
    var counterEl = lightbox.querySelector('[data-lightbox-counter]')
    var backdrop = lightbox.querySelector('[data-lightbox-backdrop]')
    var closeBtn = lightbox.querySelector('[data-lightbox-close]')
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]')
    var nextBtn = lightbox.querySelector('[data-lightbox-next]')

    var items = thumbs.map(function (thumb) {
      return { full: thumb.getAttribute('data-full'), alt: thumb.getAttribute('data-alt') || '' }
    })

    var counterFormat = counterEl ? counterEl.getAttribute('data-counter-format') : ''
    var currentIndex = 0
    var triggerEl = null
    var single = items.length < 2

    // Hide prev/next when there is only one image.
    if (single) {
      if (prevBtn) prevBtn.style.display = 'none'
      if (nextBtn) nextBtn.style.display = 'none'
    }

    function renderCounter() {
      if (!counterEl) return
      var current = String(currentIndex + 1)
      var total = String(items.length)
      if (counterFormat) {
        counterEl.textContent = counterFormat.replace('%c', current).replace('%t', total)
      } else {
        counterEl.textContent = current + ' / ' + total
      }
    }

    function show(index) {
      currentIndex = (index + items.length) % items.length
      var item = items[currentIndex]
      imageEl.setAttribute('src', item.full)
      imageEl.setAttribute('alt', item.alt)
      renderCounter()
    }

    function open(index, trigger) {
      triggerEl = trigger || null
      show(index)
      lightbox.classList.remove('hidden')
      lightbox.classList.add('flex')
      lightbox.setAttribute('aria-hidden', 'false')
      document.body.style.overflow = 'hidden'
      document.addEventListener('keydown', onKeydown)
      if (closeBtn) closeBtn.focus()
    }

    function close() {
      lightbox.classList.add('hidden')
      lightbox.classList.remove('flex')
      lightbox.setAttribute('aria-hidden', 'true')
      document.body.style.overflow = ''
      document.removeEventListener('keydown', onKeydown)
      if (triggerEl && typeof triggerEl.focus === 'function') triggerEl.focus()
      triggerEl = null
    }

    function next() {
      show(currentIndex + 1)
    }

    function prev() {
      show(currentIndex - 1)
    }

    function trapFocus(event) {
      var focusable = Array.prototype.slice.call(lightbox.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null
      })
      if (focusable.length === 0) return
      var first = focusable[0]
      var last = focusable[focusable.length - 1]
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    }

    function onKeydown(event) {
      switch (event.key) {
        case 'Escape':
          event.preventDefault()
          close()
          break
        case 'ArrowLeft':
          if (!single) {
            event.preventDefault()
            prev()
          }
          break
        case 'ArrowRight':
          if (!single) {
            event.preventDefault()
            next()
          }
          break
        case 'Tab':
          trapFocus(event)
          break
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.getAttribute('data-index'), 10) || 0
        open(index, thumb)
      })
    })

    if (closeBtn) closeBtn.addEventListener('click', close)
    if (backdrop) backdrop.addEventListener('click', close)
    if (prevBtn) prevBtn.addEventListener('click', prev)
    if (nextBtn) nextBtn.addEventListener('click', next)
  }

  function init() {
    var galleries = document.querySelectorAll('[data-photo-gallery]')
    Array.prototype.forEach.call(galleries, initGallery)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
